import { window, stack, list, vsplit, hsplit } from "./ComponentTypes";
var WindowSupplier = function () {
    return import("./Window").then(function (m) {
        return new m.Window();
    });
};
var StackSupplier = function () {
    return import("./Stack").then(function (m) {
        return new m.Stack();
    });
};
var ListSupplier = function () {
    return import("./List").then(function (m) {
        return new m.List();
    });
};
var VSplitSupplier = function () {
    return import("./Split").then(function (m) {
        return new m.VSplit();
    });
};
var HSplitSupplier = function () {
    return import("./Split").then(function (m) {
        return new m.HSplit();
    });
};
var TypeComponentSupplierMap = {};
TypeComponentSupplierMap[window] = WindowSupplier;
TypeComponentSupplierMap[stack] = StackSupplier;
TypeComponentSupplierMap[list] = ListSupplier;
TypeComponentSupplierMap[hsplit] = HSplitSupplier;
TypeComponentSupplierMap[vsplit] = VSplitSupplier;
var ComponentFactory = function (type) {
    var s = TypeComponentSupplierMap[type];
    if (s) {
        return s();
    }
    return Promise.reject({ code: "NOT_FOUND", type: type, message: "Component Type " + type + " is not registered" });
};
export { ComponentFactory };
